<template>
  <div>
    <HeroSection />
    <section class="quick-actions-section">
      <v-container>
        <v-row>
          <v-col v-for="action in quickActions" :key="action.title" cols="12" sm="6" lg="3">
            <v-card class="quick-action-card" elevation="0" :to="{ name: 'home', hash: `#${action.hash}` }">
              <span class="quick-action-card__icon"><i :class="action.icon" aria-hidden="true"></i></span>
              <h3>{{ action.title }}</h3>
              <p>{{ action.text }}</p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <PackagedService />
    <WhyChooseUs />
    <hmoAccredited />
    <OtherService />
    <ContactUs />
    <section class="faq-section">
      <v-container>
        <div class="section-heading">
          <div class="eyebrow">Common questions</div>
          <h2>Before you visit Mayon.</h2>
        </div>
        <v-expansion-panels flat class="faq-panels">
          <v-expansion-panel v-for="item in faqs" :key="item.question">
            <v-expansion-panel-header>{{ item.question }}</v-expansion-panel-header>
            <v-expansion-panel-content>{{ item.answer }}</v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </section>
  </div>
</template>

<script>
import HeroSection from '../views/LandingPage/HeroSection.vue'
import PackagedService from '../views/LandingPage/PackagedService.vue'
import WhyChooseUs from '../views/LandingPage/WhyChooseUs.vue'
import hmoAccredited from '../views/LandingPage/hmoAccredited.vue'
import OtherService from '../views/LandingPage/OtherService.vue'
import ContactUs from '../views/LandingPage/ContactUs.vue'
import { faqs, quickActions } from '@/data/mayonSite'

export default {
  name: 'HomeView',
  components: {
    HeroSection,
    PackagedService,
    WhyChooseUs,
    hmoAccredited,
    OtherService,
    ContactUs
  },
  data() {
    return {
      faqs,
      quickActions
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-actions-section {
  background: var(--mayon-bg);
  margin-top: -2.4rem;
  padding: 0 0 5rem;
  position: relative;
  z-index: 2;
}

.quick-action-card {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid var(--mayon-border) !important;
  border-radius: 24px !important;
  box-shadow: none !important;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  min-height: 206px;
  padding: 1.55rem 1.35rem;
  text-align: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: rgba(88, 184, 184, 0.36) !important;
    box-shadow: var(--mayon-shadow-card) !important;
    transform: translateY(-3px);
  }

  &__icon {
    align-items: center;
    background: rgba(88, 184, 184, 0.10);
    border-radius: 18px;
    color: var(--mayon-blue);
    display: inline-flex;
    height: 58px;
    justify-content: center;
    margin: 0 auto 1rem;
    width: 58px;

    i {
      font-size: 1.42rem;
    }
  }

  h3 {
    color: var(--mayon-navy);
    font-size: 1.05rem;
    margin: 0 0 0.45rem;
  }

  p {
    color: var(--mayon-muted);
    line-height: 1.6;
    margin: 0 auto;
    max-width: 220px;
  }
}

.faq-section {
  background: #ffffff;
  padding: 5rem 0;
}

.section-heading {
  margin: 0 auto 2rem;
  max-width: 720px;
  text-align: center;

  .eyebrow {
    color: var(--mayon-blue);
    font-size: 0.82rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    margin-bottom: 0.7rem;
    text-transform: uppercase;
  }

  h2 {
    color: var(--mayon-navy);
    font-size: clamp(2rem, 4vw, 3rem);
    letter-spacing: -0.035em;
    line-height: 1.1;
  }
}

.faq-panels {
  border: 1px solid var(--mayon-border);
  border-radius: 24px;
  margin: 0 auto;
  max-width: 860px;
  overflow: hidden;
}

.faq-panels::v-deep .v-expansion-panel::before {
  box-shadow: none;
}

.faq-panels::v-deep .v-expansion-panel-header {
  color: var(--mayon-navy);
  font-weight: 700;
}

.faq-panels::v-deep .v-expansion-panel--active .v-expansion-panel-header {
  color: var(--mayon-blue);
}

.faq-panels::v-deep .v-expansion-panel-content__wrap {
  color: var(--mayon-muted);
  line-height: 1.7;
}
</style>
